import Layout from '../../layout';
const homeRouter = {
	path: '/',
	component: Layout,
	redirect: '/',
	name: 'chinese',
	meta: {
		title: '1',
		sort: 4,
	},
	children: [
		{
			path: '/',
			component: () => import('@/pages/chinese/views/home/index.vue'),
			name: 'home',
		},
		{
			path: '/detail',
			component: () => import('@/pages/chinese/views/detail/index.vue'),
			name: 'home',
		},
		{
			path: '/searchpage',
			component: () =>
				import('@/pages/chinese/views/searchpage/index.vue'),
			name: 'searchpage',
		},
	],
};

export default homeRouter;
